import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Form, Button,
    Spinner, Container, Row, Col, Alert
} from 'react-bootstrap';
import { Redirect } from 'react-router-dom'

function Login(props) {

    var [loginStatus, setLoginStatus] = useState();
    var [username, setUsername] = useState('');
    var [password, setPassword] = useState('');
    const [validated, setValidated] = useState(false);
    const { licenseName } = useParams();
    var [license] = useState(licenseName);
    var [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === true) {
            setIsLoading(true);
            setValidated(true);
            const status = await doLogin();
            if (status !== 200) {
                // Otherwise error when trying to change state after redirect
                setIsLoading(false);
            }
        }
    };

    async function doLogin() {
        const query = `/api/${license}/login`;
        const res = await fetch(query,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                cors: 'cors',
                body: JSON.stringify({
                    username: username,
                    password: password
                })
            });
        setLoginStatus(res.status);
        return res.status;
    }

    function getError() {
        if (!loginStatus) return;
        if (loginStatus === 403) {
            return (
                <Alert variant="danger">Felaktig inloggning</Alert>
            );
        }
        else if (loginStatus === 404) {
            return (
                <Alert variant="danger">Felaktig licens</Alert>
            )
        } else if (loginStatus === 200) {
            var target = `/${license}/admin`;
            return (
                <Redirect to={target} />
            );
        } else {
            return (
                <Alert variant="danger">Ett okänt fel uppstod</Alert>
            )
        }
    }

    function getSubmitButton() {
        if (isLoading) {
            return (
                <Button disabled variant="primary">
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        style={{ marginRight: 5 }}
                    />
                    Laddar..
                </Button>
            );
        }
        else {
            return (
                <Button type="submit" variant="primary">
                    Logga in
                </Button>
            );
        }
    }

    return (
        <Container style={{ marginTop: 50 }}>
            <Row>
                <Col xs={0} md={4}></Col>
                <Col xs={12} md={4}>
                    {getError()}
                    <Form validated={validated} onSubmit={handleSubmit}>
                        <Form.Group controlId="formUsername">
                            <Form.Label>Användarnamn</Form.Label>
                            <Form.Control onChange={e => setUsername(e.target.value)} value={username} required type="text" placeholder="Ange användarnamn" />
                            <Form.Text className="text-muted">
                                Användarnamnet är samma som den användare du har i Agitura Journal
                            </Form.Text>
                        </Form.Group>

                        <Form.Group controlId="formPassword">
                            <Form.Label>Lösenord</Form.Label>
                            <Form.Control onChange={e => setPassword(e.target.value)} required type="password" placeholder="Lösenord" />
                        </Form.Group>
                        {getSubmitButton()}
                    </Form>
                </Col>
                <Col xs={0} md={4}></Col>
            </Row>
        </Container>

    );

}

export default Login;